import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ActiveSystem {
  id: string;
  code: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  marketing_url: string;
  default_features: any;
  is_active: boolean;
  order_index: number;
}

export function useActiveSystems() {
  return useQuery({
    queryKey: ['active-systems'],
    queryFn: async (): Promise<ActiveSystem[]> => {
      const { data, error } = await supabase
        .from('systems')
        .select('*')
        .eq('is_active', true)
        .order('order_index');

      if (error) throw error;
      return data || [];
    },
  });
}